import React, { useEffect, useState } from 'react';
import './Login.css';
import { useTranslation } from 'react-i18next';
import logoAdinse from '../../images/Login/adinsefull600.png';
import Loading from '../Misc/Other/Loading';
import RingLoader from "react-spinners/RingLoader";
import QRCode from 'qrcode';
function Login() {
    const { t, i18n } = useTranslation();
    const [loaded, setLoaded] = useState(true);
    const [loadedButton, setLoadedButton] = useState(true);
    const [qrUrl, setQrUrl] = useState(null);
    const [step, setStep] = useState(1);
    const [selectedLanguageFilter, setSelectedLanguageFilter] = useState(i18n.language);
    var [credenciales, setCredenciales] = useState({ username: '', password: '', token: -1 });
    var [mensajeError, setMensajeError] = useState("");
    var [botonInicioSesion, setBotonInicioSesion] = useState(<></>);
    var [botonCopiar, setBotonCopiar] = useState(<></>);
    var [botonContinuar, setBotonContinuar] = useState(<></>);

    //Registrar los cambios en las casillas de nombre y contraseña
    const handleInputChange = (event) => {
        setCredenciales({
            ...credenciales,
            [event.target.name]: event.target.value
        });
    }

    //Enviar las credenciales a las apis
    const headers = credenciales;
    const enviarDatos = (event) => {
        console.log(headers)
        setLoadedButton(false);
        event.preventDefault();
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + '/sessions/login', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'username': headers.username,
                'password': headers.password,
                'token': headers.token
            }
        })
            .then(async response => {/*Recogemos todos los datos estáticos y los guardamos en Session Storage*/
                if (response.status === 200) {//Si son correctas las credenciales, recogemos los datos
                    try {


                        setMensajeError("");
                        //var x = document.getElementById("error_message");
                        //x.style.display = "none";
                        let variables = '';
                        let idParque = 0;
                        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + '/frontEnd/configuration', { method: 'GET', credentials: 'include' })
                            .then(async (data) => {
                                //setLoaded(false);//Pantalla de carga
                                sessionStorage.setItem("configuration", JSON.stringify(await data.json()));
                                idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
                                console.log(idParque)

                                if (!sessionStorage.getItem('ScreenConfiguration')) {
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/frontEnd/scadaScreensConfiguration", { method: 'GET', credentials: 'include' })
                                        .then(async (dataScreen) => { sessionStorage.setItem('ScreenConfiguration', JSON.stringify(await dataScreen.json())); })
                                        .catch(e => { console.log(e); });
                                }
                                if (!sessionStorage.getItem('Legend')) {
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/frontEnd/statusLegend", { method: 'GET', credentials: 'include' })
                                        .then(async (dataLege) => { sessionStorage.setItem('Legend', JSON.stringify(await dataLege.json())); })
                                        .catch(e => { console.log(e); })
                                }
                                if (!sessionStorage.getItem('CTConfiguration')) {
                                    variables = '&variables=id,idCT,idDevice,idSolarFarm,name,alias,coordX,coordY';
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/CTs?idSolarFarm=" + idParque + variables, { method: 'GET', credentials: 'include' })
                                        .then(async (dataCT) => { sessionStorage.setItem('CTConfiguration', JSON.stringify(await dataCT.json())); })
                                        .catch(e => { console.log(e); });
                                }
                                if (!sessionStorage.getItem('InverterConfiguration')) {
                                    variables = '&variables=id,idSolarFarm,idCT,idDevice,idInverter,name,description,coordX,coordY,nominalPower,peakPower,mpptNumber,stringNumber';
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/inverters?idSolarFarm=" + idParque + variables, { method: 'GET', credentials: 'include' })
                                        .then(async (dataInverter) => { sessionStorage.setItem('InverterConfiguration', JSON.stringify(await dataInverter.json())); })
                                        .catch(e => { console.log(e); });
                                }
                                if (!sessionStorage.getItem('TrackerConfiguration')) {
                                    variables = '&variables=id,idSolarFarm,idCT,idInverter,idDevice,idTracker,name,coordX,coordY';
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/trackers?idSolarFarm=" + idParque + variables, { method: 'GET', credentials: 'include' })
                                        .then(async (dataTracker) => { sessionStorage.setItem('TrackerConfiguration', JSON.stringify(await dataTracker.json())); })
                                        .catch(e => { console.log(e); });
                                }
                                if (!sessionStorage.getItem('MeteoConfiguration')) {
                                    variables = '&variables=id,idSolarFarm,idDevice,idMS,name,coordX,coordY';
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/meteorologicalStation?idSolarFarm=" + idParque + variables, { method: 'GET', credentials: 'include' })
                                        .then(async (dataMeteo) => { sessionStorage.setItem('MeteoConfiguration', JSON.stringify(await dataMeteo.json())); })
                                        .catch(e => { console.log(e); });
                                }

                                if (!sessionStorage.getItem('NCUConfiguration')) {
                                    variables = '&variables=id,idSolarFarm,idDevice,idNCU,nameNCU,coordX,coordY';
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/NCU?idSolarFarm=" + idParque + variables, { method: 'GET', credentials: 'include' })
                                        .then(async (dataNCU) => { sessionStorage.setItem('NCUConfiguration', JSON.stringify(await dataNCU.json())); })
                                        .catch(e => { console.log(e); });
                                }

                                if (!sessionStorage.getItem('NCUGroups')) {
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/frontEnd/NCUGroups", { method: 'GET', credentials: 'include' })
                                        .then(async (dataNCUG) => { sessionStorage.setItem('NCUGroups', JSON.stringify(await dataNCUG.json())); })
                                        .catch(e => { console.log(e); })
                                }

                                if (!sessionStorage.getItem('commands')) {
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/frontEnd/commands", { method: 'GET', credentials: 'include' })
                                        .then(async (dataCommands) => { sessionStorage.setItem('commands', JSON.stringify(await dataCommands.json())); })
                                        .catch(e => { console.log(e); })
                                }

                                if (!sessionStorage.getItem('ZoneConfiguration')) {
                                    fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/frontEnd/zones", { method: 'GET', credentials: 'include' })
                                        .then(async (dataZone) => { sessionStorage.setItem('ZoneConfiguration', JSON.stringify(await dataZone.json())); })
                                        .catch(e => { console.log(e); });
                                }

                                var inter = setInterval(() => {
                                    if (sessionStorage.getItem('configuration') && sessionStorage.getItem('Legend') && sessionStorage.getItem('CTConfiguration') &&
                                        sessionStorage.getItem('InverterConfiguration') && sessionStorage.getItem('TrackerConfiguration') && sessionStorage.getItem('MeteoConfiguration') &&
                                        sessionStorage.getItem('NCUConfiguration') && sessionStorage.getItem('ZoneConfiguration') && sessionStorage.getItem('ScreenConfiguration') &&
                                        sessionStorage.getItem('NCUGroups') && sessionStorage.getItem('commands')) {
                                        window.open("/", "_self");
                                        clearInterval(inter);
                                    }
                                });
                            });
                    } catch (error) {
                        console.warn(error);
                    }
                } else if (response.status === 426) {//Generar qr
                    var htmlBotCopy;
                    var htmlBotContinue;
                    const data = await response.json();
                    const QRurl = data.otpauth_url;
                    const secret = data.secret;
                    const options = {
                        errorCorrectionLevel: 'H', // Mayor corrección de errores
                        scale: 10, // Escala más alta para mejor calidad
                    };

                    setStep(2);

                    const copyToClipboard = () => {
                        navigator.clipboard.writeText(secret)
                            .then(() => alert("Secret copiado al portapapeles"))
                            .catch(err => console.error("Error al copiar", err));
                    };

                    const handleContinuarClick = () => {
                        setStep(3);  // Al hacer clic en "Continuar", mostramos el nuevo formulario
                    };

                    htmlBotCopy = <button type="submit" className="btn btn-primary" onClick={copyToClipboard}>{t('scada.login.form.copy')}</button>
                    setBotonCopiar(htmlBotCopy);

                    htmlBotContinue = <button type="submit" className="btn btn-primary" onClick={handleContinuarClick}>{t('scada.login.form.continue')}</button>
                    setBotonContinuar(htmlBotContinue)

                    try {
                        const url = await QRCode.toDataURL(QRurl, options);
                        setQrUrl(url);
                    } catch (err) {
                        console.error("Error generating QR Code", err);
                    }
                } else if (response.status == 428) {
                    setStep(3);
                } else if (response.status === 401 || response.status === 400) {//Las credenciales están mal
                    setMensajeError(t('scada.login.form.errorCredentials'));
                    var x = document.getElementById("error_message");
                    x.style.display = "block";
                    setLoadedButton(true);
                } else if (response.status === 502) {//Problemas de conexion con la API
                    setMensajeError(t('scada.login.form.errorApi'));
                    var x = document.getElementById("error_message");
                    x.style.display = "block";
                    setLoadedButton(true);
                } else {//Timeout o otros errores
                    setMensajeError(t('scada.login.form.error'));
                    var x = document.getElementById("error_message");
                    x.style.display = "block";
                    setLoadedButton(true);
                }
            })
            .catch(e => {
                setMensajeError(t('scada.login.form.errorApi'));
                var x = document.getElementById("error_message");
                x.style.display = "block";
                console.error(e);
                setLoadedButton(true);
            })
    }


    useEffect(() => {
        var htmlBotSesion;
        if (credenciales.name === '' || credenciales.password === '') {
            htmlBotSesion = <button type="submit" className="btn btn-primary" disabled>{t('scada.login.form.login')}</button>
        } else {
            if (loadedButton === true || step === 3) {
                htmlBotSesion = <button type="submit" className="btn btn-primary">{t('scada.login.form.login')}</button>
            } else {
                htmlBotSesion =
                    <button type="submit" className="btn btn-primary" style={{ paddingLeft: "46%" }}>
                        <RingLoader color="rgb(255, 255, 255)" size={30} />
                    </button>
            }
        }


        setBotonInicioSesion(htmlBotSesion);
    }, [loadedButton, credenciales])

    const handleLanguageFilterChange = (e) => {
        const newLang = e.target.value;
        setSelectedLanguageFilter(newLang);
        i18n.changeLanguage(newLang);
    };
    const languages = [
        { Id: 'en', Language: t('languages.en'), Name: "English" },
        { Id: 'pt', Language: t('languages.pt'), Name: "Portuguese" },
        { Id: 'es', Language: t('languages.es'), Name: "Spanish" },
        { Id: 'it', Language: t('languages.it'), Name: "Italian" }
    ];

    if (loaded === false) {
        return (<><Loading /></>)
    } else {
        return (
            <div className="div-form-login">
                {step === 1 && ( // Mostrar formulario inicio de sesión
                    <form className="form-login" onSubmit={enviarDatos}>
                        <div className="form-content">
                            <img className="form-title" src={logoAdinse} alt="Logo" />
                            <div className="form-group mt-3">
                                <label>{t('scada.login.form.user')}</label>
                                <input
                                    type="text"
                                    className="form-control mt-1"
                                    placeholder={t('scada.login.form.placeholderUser')}
                                    name="username"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group mt-3">
                                <label>{t('scada.login.form.password')}</label>
                                <input
                                    type="password"
                                    className="form-control mt-1"
                                    placeholder={t('scada.login.form.placeholderPassword')}
                                    name="password"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div id="error_message" className="alert alert-danger" role="alert" style={{ display: "none", marginTop: "1rem" }}>
                                {mensajeError}
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-4">
                                <div className="col-md-2">
                                    <select className="form-select" value={selectedLanguageFilter || ""} onChange={handleLanguageFilterChange} style={{ minWidth: "140px" }}>
                                        {languages.map(lang => (
                                            <option key={lang.Id} value={lang.Id}>{lang.Name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    {botonInicioSesion}
                                </div>
                            </div>
                        </div>
                    </form>
                )}

                {step === 2 && (
                    <div className="div-form-login">
                        <div className='form-login'>
                            <div className="qr-container">
                                <div className="form-content">
                                    <img className="form-title" src={logoAdinse} alt="Logo" />
                                    <img className="qr" src={qrUrl} alt="Código QR" />
                                    <div className="d-grid gap-2 mt-3">
                                        {botonCopiar}
                                    </div>
                                    <div className="d-grid gap-2 mt-3">
                                        {botonContinuar}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {step === 3 && (
                    <form className="form-login" onSubmit={enviarDatos}>
                        <div className="form-content">
                            <img className="form-title" src={logoAdinse} alt="Logo" />
                            <label>{t('scada.login.form.token')}</label>
                            <input
                                type="password"
                                className="form-control mt-1"
                                placeholder={t('scada.login.form.token')}
                                name="token"
                                onChange={handleInputChange}
                            />
                            <div className="d-grid gap-2 mt-3">
                                {botonInicioSesion}
                            </div>
                        </div>
                    </form>
                )}
            </div>
        )
    }
}

export default Login